module.exports = __webpack_public_path__ + "img/user_icon.b7415864.png";